export enum SignInStatus{
    No='NO',
    Trying='TRYING',
    Yes='YES',
    InFailed='INFAILED',
    OutFailed='OUTFAILED'
}

const TEACHERS_TITLE="Teachers' Section";

const PRIVACY_HREF='https://www.gamestolearnenglish.com/pages/privacy-policy/';
const GOOGLE_LINK='https://accounts.google.com/signup/v2/webcreateaccount?hl=en&flowName=GlifWebSignIn&flowEntry=SignUp';

interface UserPaneProps{
    signIn:() => void;
    signOut:() => void;
    username:string;
    signInStatus:SignInStatus;
}

export const UserPane=function(props:UserPaneProps){
    let isSignedIn=props.username!=='';
    let teachersTitle=!isSignedIn?<h3 id='teachers-maintitle'>{TEACHERS_TITLE}</h3>:'';
    let usernameLine=isSignedIn?<h3 id='teachers-username'>{props.username}</h3>:'';

    let statusMsg='';
    if(props.signInStatus===SignInStatus.Trying)statusMsg='Signing in ...';
    if(props.signInStatus===SignInStatus.InFailed)statusMsg='Sign in failed';
    if(props.signInStatus===SignInStatus.OutFailed)statusMsg='Sign out failure';

    let showMainText=isSignedIn===false&&statusMsg==='';

    return(
        <div id='teachers-userpane'>
            {teachersTitle}
            {usernameLine}
            {statusMsg!==''&&<p className="teachers-statusmessage">{statusMsg}</p>}
            {showMainText&&<p>
                <span>Sign in with Google to set homework tasks or view your content.  You can create a new <a target='_blank' rel="noreferrer" className='teachers-link-nounderline' href={GOOGLE_LINK}>Google account</a> just for this website.</span>
                <span>  To view the privacy policy or terms of service, <a target='_blank' rel="noreferrer" href={PRIVACY_HREF} className='teachers-link-nounderline'>click here</a>.</span>
            </p>}
            <button className='teachers-button' id='teachers-button-signin' onClick={()=>{props.signIn();}} disabled={isSignedIn}>Sign In</button>
            <button className='teachers-button' id='teachers-button-signout' onClick={()=>{props.signOut();}} disabled={!isSignedIn}>Sign Out</button>
        </div>
    )
};

